import { Button, soundManager, t, useVoucherStore } from '@slot-nx/core'
import { Container, Text } from '@pixi/react'
import { TextStyle, Text as PixiText } from 'pixi.js'
import { useCallback, useRef } from 'react'
import { GameStatus, useGameStore } from '../../../domain/game/store/GameStore'
import { VoucherSoundType } from '@slot-nx/core'
import { threecomboolympusMachine } from '../../../domain/machine/threecomboolympusMachine'

export const playNowBtnTextStyle = new TextStyle({
  align: 'center',
  fontWeight: 'normal',
  fill: '#FFFFFF',
  fontFamily: 'RobotoCondensed',
  fontSize: 45,
})

export const VoucherSelectPopupButtons = () => {
  const sendEventCb = useCallback(() => {
    threecomboolympusMachine.send({ type: 'initVoucher finished' })
    useVoucherStore.setState({ isShowVoucherSelectPopup: false })
  }, [])
  const playNowTextRef = useRef<PixiText>()
  const playLaterTextRef = useRef<PixiText>()

  return (
    <Container name="VoucherButtons">
      <Button
        name="play_later_btn"
        defaultView="voucher_play_later_normal"
        hoverView="voucher_play_later_hover"
        pressedView="voucher_play_later_click"
        disabledView="voucher_play_later_unable"
        enabled={true}
        x={-380}
        y={440}
        width={341}
        height={157}
        key="play_later_btn"
        onPressing={() => {
          (playLaterTextRef.current as PixiText).position.y = 515
        }}
        onHoverEnd={() => {
          (playLaterTextRef.current as PixiText).position.y = 508
        }}
        onPress={() => {
          soundManager.play(VoucherSoundType.buttonClick)
          sendEventCb()
        }}
      />
      <Text
        text={t('voucher_select_popup_play_later_btn')}
        x={-207}
        y={508}
        anchor={[0.5, 0.5]}
        name="PLAY LATER"
        style={new TextStyle({
          align: 'center',
          fontWeight: 'normal',
          fill: '#B49CFF',
          fontFamily: 'RobotoCondensed',
          fontSize: 45,
        })}
        ref={(el) => {
          playLaterTextRef.current = el as PixiText
        }}
      />
      <Button
        name="play_now_btn"
        defaultView="play_now_normal"
        hoverView="play_now_hover"
        pressedView="play_now_click"
        disabledView="play_now_unable"
        enabled={true}
        x={30}
        y={440}
        width={341}
        height={157}
        key="play_now_btn"
        onPressing={() => {
          (playNowTextRef.current as PixiText).position.y = 515
        }}
        onHoverEnd={() => {
          (playNowTextRef.current as PixiText).position.y = 508
        }}
        onPress={() => {
          soundManager.play(VoucherSoundType.buttonClick)
          useGameStore.setState({ gameStatus: GameStatus.Voucher })
          sendEventCb()
        }}
      />
      <Text
        text={t('voucher_select_popup_play_now_btn')}
        x={205}
        y={508}
        anchor={[0.5, 0.5]}
        name="PLAY NOW"
        style={playNowBtnTextStyle}
        ref={(el) => {
          playNowTextRef.current = el as PixiText
        }}
      />

    </Container>
  )
}
